import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useEduCourseBasicInformation(courseDetail) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!courseDetail) return [];

    return [
      {
        label: t('Názov kurzu'),
        value: courseDetail.name,
      },
      { label: t('Náročnosť'), value: courseDetail.difficulty },
      {
        label: t('Celkom hodín'),
        value: courseDetail.number_hours,
      },
      {
        label: t('Cena na osobu'),
        value: courseDetail.price + ' €',
      },
      {
        label: t('Program'),
        value: courseDetail.agenda,
        isRaw: true,
      },
      {
        label: t('Certifikát'),
        value: courseDetail.certificate,
      },
    ];
  }, [courseDetail, t]);
}
